import cover from "../../../images/cover-image.jpg";

const ProfileCover = () => {
  return (
    <div
      className="relative w-full h-96 md:h-[500px] overflow-hidden flex items-end justify-center"
    >
      {/* Background Image */}
      <img
        src={cover}
        alt="Profile cover"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Simple Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-gray-900/35 to-gray-950/80" />

      {/* Subtle accent overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-green-500/0 via-emerald-500/5 to-blue-500/0 mix-blend-multiply pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 pb-12 md:pb-16 flex flex-col items-center justify-center">
        <div className="mb-4">
          <h1 className="relative text-4xl md:text-6xl font-bold text-white drop-shadow-lg bg-gradient-to-r from-white via-green-100 to-white bg-clip-text text-transparent">
            Stili Ikram
          </h1>
        </div>
        <p className="text-lg md:text-2xl text-gray-100 drop-shadow-md font-light tracking-wide max-w-2xl">
          Full Stack Developer & Creative Technologist
        </p>
      </div>
    </div>
  );
};

export default ProfileCover;
